<ion-card class="custom-card">
  <ion-row>
    @for (col of data; track col) {
      <ion-col [size]="size" class="container">
        <ion-label class="title">{{ col.label }}:</ion-label>
        <ion-text class="desc">{{ col.value }}</ion-text>
      </ion-col>
    }
  </ion-row>
  <ng-content></ng-content>
</ion-card>
